import styled from 'styled-components'

import EmptyDetails from '../../../../components/EmptyDetails'

const JobRequests = ({
  id,
  requestorName,
  company,
  companyUrl,
  email,
  location,
}) => {
  let component = <EmptyDetails message="No attached job request." />

  if (id)
    component = (
      <StyledGrid>
        <StyledJobDetails>
          <div className="title">Requestor Name</div>
          <div className="content">{requestorName}</div>
        </StyledJobDetails>
        <StyledJobDetails>
          <div className="title">Company</div>
          <div className="content">{company}</div>
        </StyledJobDetails>
        <StyledJobDetails>
          <div className="title">Company URL</div>
          <div className="content">{companyUrl}</div>
        </StyledJobDetails>
        <StyledJobDetails>
          <div className="title">Email</div>
          <div className="content">{email}</div>
        </StyledJobDetails>
        <StyledJobDetails>
          <div className="title">Location</div>
          <div className="content">{location}</div>
        </StyledJobDetails>
      </StyledGrid>
    )

  return component
}

export default JobRequests

export const StyledJobDetails = styled.div`
  display: grid;
  grid-template-columns: 130px 1fr;
  gap: 1rem;

  .title {
    font-size: 1rem;
    font-weight: 300;
    color: #676e92;
  }

  .content {
    font-size: 1rem;
    font-weight: 300;
    color: #0e1324;
  }

  .flex {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }
`

export const StyledGrid = styled.div`
  width: 100%;
  height: calc(100vh - 9rem);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`
